import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { LabelSize } from './index';
import { StatusIndications } from '../common';

export interface FormFieldUniDriver extends BaseUniDriver {
  element(): Promise<HTMLElement>;
  getChildren(): Promise<HTMLElement | null>;
  getLabel(): Promise<HTMLElement | null>;
  getLabelSize(): Promise<LabelSize>;
  isRequired(): Promise<boolean>;
  getLengthLeft(): Promise<number | null>;
  isLengthExceeded(): Promise<boolean>;
  hasTooltip(): Promise<boolean>;
  getInfoContent(): Promise<string>;
  getSuffix(): Promise<HTMLElement | null>;
  hoverInfoIcon: () => Promise<void>;
  getStatusMessage(): Promise<string>;
  hasStatus: (status: StatusIndications) => Promise<boolean>;
}
